import React from 'react';
import styles from './formulari.module.scss';
// @ts-ignore
import BotoComponent from 'components/corporatiu/Boto';

const Boto = BotoComponent as React.ComponentType<{
    text?: string;
    estil?: string;
    tag?: string;
    [key: string]: any;
}>;

type FormulariMalaltiesProps = {
    nom?: string;
    actiu?: boolean;
    [key: string]: any;
};

export default function FormulariMalalties(props: FormulariMalaltiesProps) {
    const { nom, actiu = true } = props;
    if (!actiu) {
        return <></>;
    }

    return (
        <div className={styles.formulari}>
            <div className={styles.dades}>
                <span>(*) Camps obligatoris</span>
            </div>
            <form action='https://www.3cat.cat/su/Register' method='post' name={nom} acceptCharset='ISO-8859-1'>
                {/* Secció 1: Identificació de l'entitat */}
                <section className={styles.formSeccio}>
                    <fieldset>
                        <legend>
                            <h2 className={styles.seccioTitol}>1. Identificació de l&apos;entitat</h2>
                        </legend>
                        <div className={styles.formField}>
                            <label htmlFor='MRT_PR_NE' className={styles.required}>
                                Nom de l&apos;entitat*
                            </label>
                            <input
                                name='MRT_PR_NE'
                                type='text'
                                id='MRT_PR_NE'
                                title="Nom de l'entitat - obligatori"
                                maxLength={70}
                                required
                            />
                        </div>
                        <div className={styles.formField}>
                            <label htmlFor='MRT_PR_RD' className={styles.required}>
                                Núm. del Registre del Departament de Justícia*
                            </label>
                            <input
                                id='MRT_PR_RD'
                                name='MRT_PR_RD'
                                type='text'
                                title='Núm. del Registre del Departament de Justícia - obligatori'
                                maxLength={10}
                                required
                            />
                        </div>
                        <div className={styles.formField}>
                            <label htmlFor='MRT_PR_AD'>Adreça</label>
                            <input id='MRT_PR_AD' name='MRT_PR_AD' type='text' title='Adreça' maxLength={100} />
                        </div>
                        <div className={styles.formField}>
                            <label htmlFor='MRT_PR_CP' className={styles.required}>
                                Codi postal*
                            </label>
                            <input
                                id='MRT_PR_CP'
                                name='MRT_PR_CP'
                                type='number'
                                title='Codi postal - obligatori'
                                min={0}
                                max={99999}
                                required
                            />
                        </div>
                        <div className={styles.formField}>
                            <label htmlFor='MRT_PR_PO' className={styles.required}>
                                Població*
                            </label>
                            <input
                                id='MRT_PR_PO'
                                name='MRT_PR_PO'
                                type='text'
                                title='Població - obligatori'
                                maxLength={50}
                                required
                            />
                        </div>
                        <div className={styles.formField}>
                            <label htmlFor='MRT_PR_NA'>Nombre d&apos;associats</label>
                            <input id='MRT_PR_NA' name='MRT_PR_NA' type='number' title="Nombre d'associats" />
                        </div>
                        <div className={styles.formField}>
                            <label htmlFor='MRT_PR_IT'>Implantació territorial de l&apos;entitat</label>
                            <input
                                id='MRT_PR_IT'
                                name='MRT_PR_IT'
                                type='text'
                                title="Implantació territorial de l'entitat"
                                maxLength={50}
                            />
                        </div>
                        <div className={styles.formField}>
                            <label htmlFor='MRT_PR_PR' className={styles.required}>
                                Persona de contacte*
                            </label>
                            <input
                                id='MRT_PR_PR'
                                name='MRT_PR_PR'
                                type='text'
                                title='Persona de contacte - obligatori'
                                maxLength={100}
                                required
                            />
                        </div>
                        <div className={styles.formField}>
                            <label htmlFor='MRT_PR_CO' className={styles.required}>
                                Càrrec*
                            </label>
                            <input
                                id='MRT_PR_CO'
                                name='MRT_PR_CO'
                                type='text'
                                title='Càrrec - obligatori'
                                maxLength={50}
                                required
                            />
                        </div>
                        <div className={styles.formField}>
                            <label htmlFor='MRT_PR_TE' className={styles.required}>
                                Telèfons*
                            </label>
                            <input
                                id='MRT_PR_TE'
                                name='MRT_PR_TE'
                                type='text'
                                title='Telèfons - obligatori'
                                maxLength={150}
                                required
                            />
                        </div>
                        <div className={styles.formField}>
                            <label htmlFor='MRT_PR_AE' className={styles.required}>
                                Adreça electrònica*
                            </label>
                            <input
                                id='MRT_PR_AE'
                                name='MRT_PR_AE'
                                type='email'
                                title='Adreça electrònica - obligatori'
                                maxLength={150}
                                required
                            />
                        </div>
                        <div className={styles.formField}>
                            <label htmlFor='MRT_PR_WE' className={styles.required}>
                                Web de l&apos;entitat*
                            </label>
                            <input
                                id='MRT_PR_WE'
                                name='MRT_PR_WE'
                                type='text'
                                title="Web de l'entitat - obligatori"
                                maxLength={150}
                                required
                            />
                        </div>
                    </fieldset>
                </section>

                {/* Secció 2: Proposta de malaltia */}
                <section className={styles.formSeccio}>
                    <fieldset>
                        <legend>
                            <h2 className={styles.seccioTitol}>2. Proposta de malaltia</h2>
                        </legend>
                        <div className={styles.formField}>
                            <label htmlFor='MRT_PR_NM' className={styles.required}>
                                Nom de la malaltia*
                            </label>
                            <textarea
                                maxLength={125}
                                name='MRT_PR_NM'
                                id='MRT_PR_NM'
                                title='Nom de la malaltia - obligatori'
                                required
                            />
                            <span className={styles.mesinfoInput}>Màxim 125 caràcters, espais inclosos</span>
                        </div>
                        <div className={styles.formField}>
                            <label htmlFor='MRT_PR_MNE' className={styles.required}>
                                Especialitat a què pertany*
                            </label>
                            <textarea
                                maxLength={125}
                                name='MRT_PR_MNE'
                                id='MRT_PR_MNE'
                                title='Especialitat a què pertany - obligatori'
                                required
                            />
                            <span className={styles.mesinfoInput}>Màxim 125 caràcters, espais inclosos</span>
                        </div>
                    </fieldset>
                </section>

                {/* Secció 3: Informació bàsica */}
                <section className={styles.formSeccio}>
                    <fieldset>
                        <legend>
                            <h2 className={styles.seccioTitol}>3. Informació bàsica que s&apos;ha de facilitar</h2>
                        </legend>

                        <div className={styles.formField}>
                            <h3 className={styles.titolSubseccio}>3.1 Prevalença</h3>
                            <label htmlFor='MRT_PR_PC' className={styles.hideText}>
                                Prevalença a Catalunya*
                            </label>
                            <textarea maxLength={100} name='MRT_PR_PC' id='MRT_PR_PC' required />
                            <span className={styles.mesinfoInput}>Màxim 100 caràcters, espais inclosos</span>
                        </div>
                        <div className={styles.formField}>
                            <label htmlFor='MRT_PR_PE' className={styles.hideText}>
                                Prevalença a l&apos;Estat*
                            </label>
                            <textarea maxLength={100} name='MRT_PR_PE' id='MRT_PR_PE' required />
                            <span className={styles.mesinfoInput}>Màxim 100 caràcters, espais inclosos</span>
                        </div>
                        <div className={styles.formField}>
                            <h3 className={styles.titolSubseccio}>3.2 Morbiditat</h3>
                            <label htmlFor='MRT_PR_MBC' className={styles.hideText}>
                                Morbiditat a Catalunya*
                            </label>
                            <textarea maxLength={100} name='MRT_PR_MBC' id='MRT_PR_MBC' required />
                            <span className={styles.mesinfoInput}>Màxim 100 caràcters, espais inclosos</span>
                        </div>
                        <div className={styles.formField}>
                            <label htmlFor='MRT_PR_MBE' className={styles.hideText}>
                                Morbiditat a l&apos;Estat*
                            </label>
                            <textarea maxLength={100} name='MRT_PR_MBE' id='MRT_PR_MBE' required />
                            <span className={styles.mesinfoInput}>Màxim 100 caràcters, espais inclosos</span>
                        </div>
                        <div className={styles.formField}>
                            <h3 className={styles.titolSubseccio}>3.3 Mortalitat</h3>
                            <label htmlFor='MRT_PR_MTC' className={styles.hideText}>
                                Mortalitat a Catalunya*
                            </label>
                            <textarea maxLength={100} name='MRT_PR_MTC' id='MRT_PR_MTC' required />
                            <span className={styles.mesinfoInput}>Màxim 100 caràcters, espais inclosos</span>
                        </div>
                        <div className={styles.formField}>
                            <label htmlFor='MRT_PR_MTE' className={styles.hideText}>
                                Mortalitat a l&apos;Estat*
                            </label>
                            <textarea maxLength={100} name='MRT_PR_MTE' id='MRT_PR_MTE' required />
                            <span className={styles.mesinfoInput}>Màxim 100 caràcters, espais inclosos</span>
                        </div>
                        <div className={styles.formField}>
                            <h3 className={styles.titolSubseccio}>3.4 Anys de vida perduts per mort prematura</h3>
                            <label htmlFor='MRT_PR_AMC' className={styles.hideText}>
                                Anys de vida perduts per mort prematura a Catalunya
                            </label>
                            <textarea maxLength={100} name='MRT_PR_AMC' id='MRT_PR_AMC' />
                            <span className={styles.mesinfoInput}>Màxim 100 caràcters, espais inclosos</span>
                        </div>
                        <div className={styles.formField}>
                            <label htmlFor='MRT_PR_AME' className={styles.hideText}>
                                Anys de vida perduts per mort prematura a l&apos;Estat
                            </label>
                            <textarea maxLength={100} name='MRT_PR_AME' id='MRT_PR_AME' />
                            <span className={styles.mesinfoInput}>Màxim 100 caràcters, espais inclosos</span>
                        </div>
                        <div className={styles.formField}>
                            <h3 className={styles.titolSubseccio}>3.5 Anys de vida perduts per discapacitat</h3>
                            <label htmlFor='MRT_PR_ADC' className={styles.hideText}>
                                Anys de vida perduts per discapacitat a Catalunya
                            </label>
                            <textarea maxLength={100} name='MRT_PR_ADC' id='MRT_PR_ADC' />
                            <span className={styles.mesinfoInput}>Màxim 100 caràcters, espais inclosos</span>
                        </div>
                        <div className={styles.formField}>
                            <label htmlFor='MRT_PR_ADE' className={styles.hideText}>
                                Anys de vida perduts per discapacitat a l&apos;Estat
                            </label>
                            <textarea maxLength={100} name='MRT_PR_ADE' id='MRT_PR_ADE' />
                            <span className={styles.mesinfoInput}>Màxim 100 caràcters, espais inclosos</span>
                        </div>
                        <div className={styles.formField}>
                            <h3 className={styles.titolSubseccio}>3.6 Cost de la condició clínica</h3>
                            <label htmlFor='MRT_PR_CC' className={styles.hideText}>
                                Cost de la condició clínica a Catalunya
                            </label>
                            <textarea maxLength={100} name='MRT_PR_CC' id='MRT_PR_CC' />
                            <span className={styles.mesinfoInput}>Màxim 100 caràcters, espais inclosos</span>
                        </div>
                        <div className={styles.formField}>
                            <label htmlFor='MRT_PR_CE' className={styles.hideText}>
                                Cost de la condició clínica a l&apos;Estat
                            </label>
                            <textarea maxLength={100} name='MRT_PR_CE' id='MRT_PR_CE' />
                            <span className={styles.mesinfoInput}>Màxim 100 caràcters, espais inclosos</span>
                        </div>
                        <div className={styles.formField}>
                            <h3 className={styles.titolSubseccio}>3.7 Nombre de grups de recerca coneguts</h3>
                            <label htmlFor='MRT_PR_GC' className={styles.hideText}>
                                Nombre de grups de recerca coneguts a Catalunya
                            </label>
                            <textarea maxLength={100} name='MRT_PR_GC' id='MRT_PR_GC' />
                            <span className={styles.mesinfoInput}>Màxim 100 caràcters, espais inclosos</span>
                        </div>
                        <div className={styles.formField}>
                            <label htmlFor='MRT_PR_GE' className={styles.hideText}>
                                Nombre de grups de recerca coneguts a l&apos;Estat
                            </label>
                            <textarea maxLength={100} name='MRT_PR_GE' id='MRT_PR_GE' />
                            <span className={styles.mesinfoInput}>Màxim 100 caràcters, espais inclosos</span>
                        </div>
                    </fieldset>
                </section>

                {/* Secció 4: Altres consideracions */}
                <section className={styles.formSeccio}>
                    <fieldset>
                        <div className={styles.formField}>
                            <legend>
                                <h2 className={styles.seccioTitol}>4. Altres consideracions</h2>
                            </legend>
                            <div className={styles.formField}>
                                <label htmlFor='MRT_PR_AC'>Altres consideracions</label>
                                <textarea maxLength={2600} name='MRT_PR_AC' id='MRT_PR_AC' />
                                <span className={styles.mesinfoInput}>Màxim 2.600 caràcters, espais inclosos</span>
                            </div>
                        </div>
                    </fieldset>
                </section>

                {/* Avís legal i enviament */}
                <section className={styles.formSeccio}>
                    <fieldset>
                        <div className={styles.formField}>
                            <label htmlFor='avislegal'>
                                <input name='avislegal' id='avislegal' type='checkbox' required />
                                <span>
                                    He llegit i accepto les condicions de l&apos;
                                    <a
                                        href='https://www.3cat.cat/avis-legal/privacitat/fundacio-la-marato/'
                                        target='_blank'
                                        rel='noopener noreferrer'
                                        title='Avís legal de la CCMA'
                                        className={styles.linkForm}
                                    >
                                        avís legal
                                    </a>
                                    *
                                </span>
                            </label>
                            <label htmlFor='infomarato_check'>
                                <input name='infomarato_check' id='infomarato_check' type='checkbox' />
                                <input type='hidden' name='infomarato' value='off' />
                                <span>
                                    Vull rebre{' '}
                                    <a
                                        href='https://www.3cat.cat/tv3/marato/dades/'
                                        target='_blank'
                                        rel='noopener noreferrer'
                                        title='Informació de La Marató'
                                        className={styles.linkForm}
                                    >
                                        informació de La Marató
                                    </a>
                                </span>
                            </label>
                        </div>
                        <div className={styles.grupBotons}>
                            <Boto text='Envia' estil='neutral' tag='button' type='submit' />
                        </div>
                    </fieldset>
                </section>

                <input type='hidden' name='hiTarget' value='https://www.3cat.cat/tv3/marato/recerca/proposta-malalties/ok/' />
                <input type='hidden' name='hiErrTarget' value='https://www.3cat.cat/tv3/marato/recerca/proposta-malalties/ko/' />
                <input type='hidden' name='hiPortal' value='tvc' />
                <input type='hidden' name='hiRegServiceId' value='MARATO_PROMALALT' />
                <input type='hidden' name='hiAction' value='150' />
                <input type='hidden' name='hiServiceId' value='MARATO_PROMALALT' />
            </form>
        </div>
    );
}
